import showSpinner from '@services/addSpinnerOnQueryStarted';
import appendPath, { toQueryString } from '@services/path';
import { UTILITIES_CALENDAR_RULE_TAG } from '@apis/utilities/index';

const BASE_PATH = 'api/v1/manager/calendarRules';
const appendToApiPath = appendPath(BASE_PATH);

export const CALENDAR_RULES_TAG = 'CalendarRules';
export const CALENDAR_RULES_TAGS = [CALENDAR_RULES_TAG];

/** @typedef {{ page: number; pageSize: number; search: string; }} CalendarRulesQueryString */

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').QueryDefinition<
*    CalendarRulesQueryString|void,
*    any,
*    any,
*    { calendarRulesInfo: Dto.ICalendarRuleInfo[]; totalCount: number }
* >}
*/
const getCalendarRules = (builder) => builder.query({
    query: (queryParams) => ({ url: `${BASE_PATH}${toQueryString(queryParams)}`, method: 'GET' }),
    async onQueryStarted(id, api) { await showSpinner(api); },
    providesTags: [CALENDAR_RULES_TAG],
});

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').MutationDefinition<Dto.ICalendarRuleInfo, any, any, Dto.ICalendarRuleInfo>}
 */
const create = (builder) =>
    builder.mutation({
        query: (setup) => ({ url: BASE_PATH, method: 'POST', data: setup }),
        async onQueryStarted(id, api) { await showSpinner(api); },
        invalidatesTags: [CALENDAR_RULES_TAG, UTILITIES_CALENDAR_RULE_TAG],
    });

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').MutationDefinition<Dto.ICalendarRuleInfo, any, any, Dto.ICalendarRuleInfo>}
 */
const update = (builder) =>
    builder.mutation({
        query: (setup) => ({ url: appendToApiPath(setup.calendarRuleId), method: 'PUT', data: setup }),
        async onQueryStarted(id, api) { await showSpinner(api); },
        invalidatesTags: [CALENDAR_RULES_TAG, UTILITIES_CALENDAR_RULE_TAG],
    });

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').MutationDefinition<Dto.ICalendarRuleInfo, any, any, void>}
 */
const deleteCalendarRule = (builder) =>
    builder.mutation({
        query: (calendarRuleId) => ({ url: appendToApiPath(calendarRuleId), method: 'DELETE' }),
        async onQueryStarted(id, api) { await showSpinner(api); },
        invalidatesTags: [CALENDAR_RULES_TAG, UTILITIES_CALENDAR_RULE_TAG],
    });

// eslint-disable-next-line import/prefer-default-export
export const endpointsManagerCalendarRules = (builder) => ({
    getCalendarRules: getCalendarRules(builder),
    createCalendarRule: create(builder),
    updateCalendarRule: update(builder),
    deleteCalendarRule: deleteCalendarRule(builder),
});
